export const CALL_STATUSES = [
  "dispatched",
  "accepted",
  "on_scene",
  "transporting",
  "delivered",
  "completed",
];

export const STATUS_META = {
  unassigned: { label: "Unassigned", cls: "bg-[#8A90A3]/15 text-[#4A5270] dark:bg-[#8A90A3]/25 dark:text-[#B6BCCC]" },
  dispatched: { label: "Dispatched", cls: "bg-[#B07A00]/15 text-[#8A5A00] dark:bg-[#B07A00]/25 dark:text-[#E4AE42]" },
  accepted: { label: "Accepted", cls: "bg-[#0096FF]/12 text-[#0B5CAD] dark:bg-[#0096FF]/22 dark:text-[#63B3FF]" },
  on_scene: { label: "On Scene", cls: "bg-[#0096FF]/12 text-[#0B5CAD] dark:bg-[#0096FF]/22 dark:text-[#63B3FF]" },
  transporting: { label: "Transporting", cls: "bg-[#2C6BC2]/14 text-[#1F4E8F] dark:bg-[#2C6BC2]/28 dark:text-[#74A9EC]" },
  delivered: { label: "Delivered", cls: "bg-[#1E7E34]/14 text-[#1E7E34] dark:bg-[#1E7E34]/28 dark:text-[#57D57F]" },
  completed: { label: "Completed", cls: "bg-[#1E7E34]/16 text-[#166028] dark:bg-[#1E7E34]/28 dark:text-[#57D57F]" },
  cancelled: { label: "Cancelled", cls: "bg-[#B14037]/15 text-[#8f2f27] dark:bg-[#B14037]/28 dark:text-[#F0938A]" },
};

export const TRACKING_STAGES = [
  { key: "dispatched_at", label: "Dispatched" },
  { key: "accepted_at", label: "Accepted" },
  { key: "on_scene_at", label: "On Scene" },
  { key: "transporting_at", label: "Transporting" },
  { key: "delivered_at", label: "Delivered" },
  { key: "completed_at", label: "Completed" },
];

export function statusMeta(s) {
  return STATUS_META[s] || { label: s || "—", cls: "bg-[#8A90A3]/15 text-[#4A5270] dark:bg-[#8A90A3]/25 dark:text-[#B6BCCC]" };
}

export function fmtDate(v, withTime = true) {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d.getTime())) return "—";
  const opts = withTime
    ? { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" }
    : { month: "short", day: "numeric", year: "numeric" };
  return d.toLocaleString(undefined, opts);
}

export function fmtTime(v) {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, { hour: "numeric", minute: "2-digit" });
}

export function timeAgo(v) {
  if (!v) return "";
  const d = new Date(v).getTime();
  const s = Math.floor((Date.now() - d) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
}

export function initials(name) {
  if (!name) return "?";
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join("");
}

export function mapsDir(...parts) {
  const q = parts.filter(Boolean).join(", ");
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(q)}`;
}

export function isToday(v) {
  if (!v) return false;
  const d = new Date(v);
  if (isNaN(d.getTime())) return false;
  const n = new Date();
  return d.getFullYear() === n.getFullYear() && d.getMonth() === n.getMonth() && d.getDate() === n.getDate();
}

export function monthLabel(m) {
  if (!m) return "";
  const [y, mm] = m.split("-");
  const d = new Date(Number(y), Number(mm) - 1, 1);
  if (isNaN(d.getTime())) return m;
  return d.toLocaleString(undefined, { month: "long", year: "numeric" });
}

export function currentMonth() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
}

export function monthOptions(count = 12) {
  const out = [];
  const d = new Date();
  for (let i = 0; i < count; i++) {
    const m = new Date(d.getFullYear(), d.getMonth() - i, 1);
    out.push(`${m.getFullYear()}-${String(m.getMonth() + 1).padStart(2, "0")}`);
  }
  return out;
}
